import React, { useState, useEffect, Fragment } from 'react';
import {
    Row, Card, CustomInput,
    CardTitle, Label,
    Input, Button,
    CardImg, Modal,
    ModalBody, InputGroup,
    InputGroupAddon,
    InputGroupText,

    Col,
    ModalHeader,
    ModalFooter,
} from 'reactstrap';
import { default as ReactSelect } from "react-select";
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import moment from 'moment';
import VoucherInfo from './VoucherInfo';
import { components } from "react-select";
import parse from 'htmlparser2';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { getGroupID, AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
    putAPI_approve_voucher
} from '../../../../../../../constants/APIs';

const VoucherConnection = ({ invitation, handleShow, voucherList, handleApproval,
    voucherId, toggle, visible, LoadData, extractData, groups, property, propertyId
    , invitationtype }) => {
    const [selectedGroup, setSelectedGroup] = useState(getGroupID());
    const [selectedProperty, setSelectedProperty] = useState(propertyId);
    let [connectedItem, setConnectedItem] = useState([{
        'groupId': '',
        'propertyId': ''
    }]);
    let [optionSelected, setOptionSelected] = useState({
        selectedGroups: [],
        selectedProperties: []
    });
    // if (groups.length === 1) {
    //     setOptionSelected({ ...optionSelected, selectedGroups: { value: groups[0].groupId, label: groups[0].groupName } });
    // }
    // if (property.length === 1) {
    //     setOptionSelected({ ...optionSelected, selectedProperties: { value: property[0].propertyId, label: property[0].propertyName } });
    // }
    const [done, setDone] = useState(true);
    let groupOptions = [];
    groupOptions.push({ value: '-1', label: 'select all', key: '1' });
    let propertyOptions = [];
    propertyOptions.push({ value: '-1', label: 'select all', key: '1' });
    const [properties, setProperties] = useState(property);
    const handleProperties = (selected) => {
        if (selected.length > 0) {
            let list = [];
            if (selected[0].value !== "-1") {
                selected.map((g) => {
                    property.map((p) => {
                        if (p.groupId === g.value) {
                            list.push(p);
                        }
                    });
                    setProperties(list);

                });
            } else {
                groups.map((g) => {
                    property.map((p) => {
                        if (p.groupId === g.groupId) {
                            list.push(p);
                        }
                    });
                    setProperties(list);
                });
            }
        }
    };
    useEffect(() => {
        if (done) {
            if (groups.length === 1) {
                setOptionSelected({
                    ...optionSelected, selectedGroups: [{ value: groups[0].groupId, label: groups[0].groupName }]
                });
            }
            if (properties.length === 1) {
                setOptionSelected({
                    ...optionSelected, selectedProperties: [{ value: properties[0].propertyId, label: properties[0].propertyName }]
                });
            }
            setDone(false);
        }
    }, [optionSelected]);
    const handleSave = () => {
        let list = [];
        let propertylist = [];
        let voucher = voucherList.filter((v) => v.id === voucherId && v.invitationId ===
            invitation.invitationId && v.approvalStatus === '1');
        if (groups.length === 1 && property.length === 1) {
            handleApproval(voucher[0].id, voucher[0].invitationId);
            toggle();
            extractData()
            return;
        }
        if (optionSelected.selectedGroups.length > 0 && optionSelected.selectedProperties.length > 0) {
            if (optionSelected.selectedGroups[0].value === "-1" && optionSelected.selectedProperties[0].value === "-1") {
                groups.map((g) => {
                    properties.map((p) => {
                        voucherList.map((v) => {
                            if (v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId) {
                                if (g.groupId === p.groupId && (invitation.groupId !== g.groupId || invitation.propertyId !== p.propertyId)) {
                                    propertylist.push({
                                        'invitationId': invitation.invitationId,
                                        'groupId': invitation.groupId,
                                        'propertyId': invitation.propertyId,
                                        'sellerGroupId': g.groupId,
                                        'sellerPropertyId': p.propertyId,
                                        'voucherId': v.id,
                                        'processingFee': invitation.processingFee,
                                        'sellFutureVouchers': invitation.sellFutureVouchers
                                    });
                                }
                            }
                        });
                    })
                });
            }
            else if (optionSelected.selectedGroups[0].value !== "-1" && optionSelected.selectedProperties[0].value === "-1") {
                optionSelected.selectedGroups.map((g) => {
                    properties.map((p) => {
                        voucherList.map((v) => {
                            if (v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId) {
                                if (g.value !== "-1" && p.groupId === g.value && invitation.propertyId !== p.propertyId) {
                                    propertylist.push({
                                        'invitationId': invitation.invitationId,
                                        'groupId': invitation.groupId,
                                        'propertyId': invitation.propertyId,
                                        'sellerGroupId': g.value,
                                        'sellerPropertyId': p.propertyId,
                                        'processingFee': invitation.processingFee,
                                        'voucherId': v.id,
                                        'sellFutureVouchers': invitation.sellFutureVouchers
                                    });
                                }
                            }
                        });
                    })
                });
            }
            else if (optionSelected.selectedGroups[0].value === "-1" && optionSelected.selectedProperties[0].value !== "-1") {
                groups.map((g) => {
                    optionSelected.selectedProperties.map((p) => {
                        voucherList.map((v) => {
                            // console.log(v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId);
                            if (v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId) {
                                // console.log(p.value !== "-1" && invitation.propertyId !== p.value);
                                if (p.value !== "-1" && invitation.propertyId !== p.value) {
                                    propertylist.push({
                                        'invitationId': invitation.invitationId,
                                        'groupId': invitation.groupId,
                                        'propertyId': invitation.propertyId,
                                        'sellerGroupId': g.groupId,
                                        'voucherId': v.id,
                                        'processingFee': invitation.processingFee,
                                        'sellerPropertyId': p.value,
                                        'sellFutureVouchers': invitation.sellFutureVouchers
                                    });
                                }
                            }
                        });
                    })
                });
            }
            else if (optionSelected.selectedGroups[0].value !== "-1" && optionSelected.selectedProperties[0].value !== "-1") {
                optionSelected.selectedGroups.map((g) => {
                    optionSelected.selectedProperties.map((p) => {
                        voucherList.map((v) => {
                            if (v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId) {
                                if (invitation.propertyId !== p.propertyId) {
                                    // console.log(v.thirdPartyVoucher && v.approvalStatus === '1' && v.id === voucherId);
                                    propertylist.push({
                                        'invitationId': invitation.invitationId,
                                        'groupId': invitation.groupId,
                                        'propertyId': invitation.propertyId,
                                        'sellerGroupId': g.value,
                                        'sellerPropertyId': p.value,
                                        'voucherId': v.id,
                                        'processingFee': invitation.processingFee,
                                        'sellFutureVouchers': invitation.sellFutureVouchers
                                    });
                                }
                            }
                        });
                    })
                });
            }

            // console.log(invitation, voucher, propertylist
            // );
            propertylist = propertylist.filter((f) => f.sellerPropertyId !== invitation.propertyId
            );
            AxiosAPI({
                url: `${putAPI_approve_voucher}`,
                method: 'put',
                data: {
                    'propertylist': propertylist, 'VoucherList': [({
                        'invitationId': invitation.invitationId,
                        'status': 'Approve',
                        'voucherId': voucher.length > 0 ? voucher[0].id : '0',
                        'groupId': invitation.groupId,
                        'propertyId': invitation.propertyId,
                        'Type': 'Invite',
                    })]
                }
            }).then((data) => {
                extractData();
                handleShow();
                toggle();

            });
        }
    }
    const handleGroupChange = async (selected) => {
        setOptionSelected({ ...optionSelected, selectedGroups: selected });
        handleProperties(selected);
    };
    const hanldePropertyChange = async (selected) => {
        setOptionSelected({ ...optionSelected, selectedProperties: selected });
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}
                size="lg" style={{ maxWidth: '40%' }}>
                <ModalHeader toggle={toggle}>
                    {invitation !== undefined && (
                        invitation.type === 'Sell' ?
                            <p>{invitation.propertyName} invitation to sell your voucher </p>
                            : <p>{invitation.propertyName} invitation to sell their voucher </p>
                    )}
                </ModalHeader>
                <ModalBody>
                    <Row className="col-md-12 my-2" >
                        <Label className='mt-2 ml-3 mr-1'>Group : </Label>
                        <div className='ml-1' style={{ width: "600px" }}>
                            {groups.map((m, index) => {
                                groupOptions.push({ value: m.groupId, label: m.groupName, key: m.groupId });
                            })}
                            {groups.length > 1 ? <ReactSelect
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                options={groupOptions}
                                style={{ width: '230px', marginLeft: '4px' }}
                                placeholder='Please select group'
                                onChange={handleGroupChange}
                                allowSelectAll={true}
                                value={optionSelected.selectedGroups}
                            // 
                            ></ReactSelect>
                                :
                                <Label className='mt-2 ml-3'>{groups[0].groupName}</Label>}
                        </div>
                    </Row>
                    <Row className="col-md-12 my-3"  >
                        <Label className='mt-2 ml-2 mr-1'>Property  : </Label>
                        {properties.map((m, index) => {
                            propertyOptions.push({ value: m.propertyId, label: m.propertyName, key: m.propertyId });
                        })}
                        <div style={{ width: "600px" }}>
                            <ReactSelect
                                options={propertyOptions}
                                className="react-select"
                                classNamePrefix="react-select"
                                isMulti={true}
                                name="form-field-name"
                                style={{ width: '230px', marginLeft: '4px' }}
                                onChange={hanldePropertyChange}
                                allowSelectAll={true}
                                components={{ Input: CustomSelectInput }}
                                placeholder='Please select property'
                                value={optionSelected.selectedProperties}
                            //
                            ></ReactSelect>

                        </div>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleSave()}>
                        Save
                    </Button>
                    <Button onClick={() => toggle()}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    );
};
export default VoucherConnection;